import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['prefecture', 'city']

  changePrefecture () {
    fetch(`/area/prefectures/${this.prefectureTarget.value}/cities.json`)
      .then(response => response.json())
      .then((cities) => {
        this.cityTarget.innerHTML = cities.map((city) => (
          `<option value="${city.id}">${city.name}</option>`
        ))
      })
  }
}
